// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
import TabPage from "./../factories/tab-page";
import TabController from "./../factories/tab-controller";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import "./../bindings/bao-tabs";
import AppTabController from "../services/app-tab-controller";
function ServiceProviderViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.Initialized = ko.observable(false);
    self.IsReadonly = ko.observable(false);
    self.TabViewModel = new TabController(false);
    self.ServiceProviderTabs = ko.observableArray();
    self.ServiceProviderTabs.subscribe(function (newValue) {
        if (self.ServiceProviderTabs() != null) {
            self.TabViewModel.Tabs([]);
            $.each(ko.map.toJS(newValue), function (index, item) {
                var newTab = new TabPage(null, item.Caption);
                newTab.AutoSelect = false;
                newTab.Url(item.WebUrl);
                newTab.IsClosable(false);
                newTab.PreLoad(false);
                newTab.TabLoaded = function () { };
                self.TabViewModel.AddTab(newTab);
            });
            if (self.TabViewModel.Tabs().length > 0) {
                self.TabViewModel.SelectTab(self.TabViewModel.Tabs()[0]);
            }
        }
    });
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.ServiceProvider().trim())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.BeforeClose = function (fn) {
        if (tabPage.DirtyFlag() == true && self.SaveAllowed() === true) {
            var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSaveCheck"), "question");
            questionDialog.DialogResult.subscribe(function (result) {
                if (result === true) {
                    if (self.CompleteCheck()) {
                        tabPage.IsLoading(true);
                        self.Save().done(function (data) {
                            self.UnlockServiceProvider().then(function () {
                                tabPage.IsLoading(false);
                                fn();
                            });
                        });
                    }
                }
                else if (result === false) {
                    tabPage.IsLoading(true);
                    self.UnlockServiceProvider().then(function () {
                        tabPage.IsLoading(false);
                        fn();
                    });
                }
            });
        }
        else {
            self.UnlockServiceProvider().then(fn);
        }
    };
    self.UnlockServiceProvider = function () {
        return Bao.post("ServiceProvider/UnlockServiceProvider", JSON.stringify({
            sessionTabId: tabPage.SessionTabId
        }));
    };
    self.PerformRefresh = function () {
        tabPage.IsLoading(true);
        Bao.post("ServiceProvider/GetServiceProvider", JSON.stringify({
            id: self.OpenData()
        }), function (value) {
            tabPage.ObjectId(value.ServiceProviderId);
            delete value.ServiceProviderTabs;
            ko.map.fromJS(value, self);
            self.TabViewModel.RefreshTabs().then(function () {
                tabPage.IsLoading(false);
                tabPage.DirtyFlag(false);
            });
        });
    };
    self.Save = function () {
        tabPage.IsLoading(true);
        return Bao.post(self.SaveUrl, JSON.stringify({
            serviceProvider: self.MinimizeEntity()
        }), function (value) {
            self.SaveTime(value.Result);
            self.TabViewModel.SaveTabs(value.Result).then(function () {
                tabPage.DirtyFlag(false);
                self.PerformRefresh();
            });
        });
    };
    self.Delete = function () {
        tabPage.IsLoading(true);
        return Bao.post("ServiceProvider/Delete", JSON.stringify({
            serviceProvider: self.MinimizeEntity()
        }), function (value) {
            tabPage.IsLoading(false);
            AppTabController.RemoveTab(tabPage);
        });
    };
    tabPage.MenuEvents.push(BaoMenu.registerEvent(function (value) {
        if (tabPage.IsActiveTab() == true) {
            switch (value.ActionKey()) {
                case "ServiceProviderSave":
                    if (self.CompleteCheck() == true) {
                        self.Save();
                    }
                    break;
                case "ServiceProviderRefresh":
                    self.BeforeRefresh();
                    break;
                case "ServiceProviderDelete":
                    self.BeforeDelete();
                    break;
            }
        }
    }));
    self.loaded = function () {
        self.InitPaging();
        tabPage.DirtyFlag.reset();
        tabPage.IsLoading(false);
    };
}
Bao.inherit(ServiceProviderViewModel, SearchPaging);
ServiceProviderViewModel.prototype.PrimaryKey = "ServiceProviderId";
ServiceProviderViewModel.prototype.RefreshUrl = "ServiceProvider/GetServiceProvider";
ServiceProviderViewModel.prototype.SaveUrl = "ServiceProvider/SaveServiceProvider";
ServiceProviderViewModel.prototype.PermissionForward = "ServiceProviderMoveForwardSearch";
ServiceProviderViewModel.prototype.PermissionBackward = "ServiceProviderMoveBackwardSearch";
export default ServiceProviderViewModel;